import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { lazy, StrictMode } from "react";
import { Provider as ReduxProvider } from "react-redux";

import { ApikeyProvider } from "safesystem_apikey-manager";
import { ErrorFallback } from "safesystem_client-component-lib";

import { apiHost, appVersion } from "@/lib/config";
import { GeodataProvider } from "@/lib/geodataContext";
import { getLogger } from "@/lib/logApi";
import { ScreenWidthProvider } from "@/lib/screenWidthContext";
import store from "@/store";

const Layout = lazy(() => import("@/Layout"));

import "./index.css";

const log = getLogger();
log.info(`SafeRoads Professional version: ${appVersion}`);

const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
	const root = createRoot(rootElement);
	root.render(
		<StrictMode>
			<ErrorBoundary FallbackComponent={ErrorFallback}>
				<ReduxProvider store={store}>
					<ApikeyProvider host={apiHost}>
						<ScreenWidthProvider>
							<GeodataProvider>
								<Layout />
							</GeodataProvider>
						</ScreenWidthProvider>
					</ApikeyProvider>
				</ReduxProvider>
			</ErrorBoundary>
		</StrictMode>
	);
}
